import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate, useLocation} from 'react-router-dom';
import { Helmet } from 'react-helmet';
import axios from 'config/axios';
import Table from 'components/Table';
import Tabs from 'components/Tabs';
import Dropdown from 'components/Dropdown';

import './index.css';
import Header from 'components/Header';

const TABS = ['Purchase History', 'Usage History'];

function Credits() {
    const [usages, setUsages] = useState({}); 
    const [organizationInfo, setOrganizationInfo] = useState([]); 
    const [tabIndex, setTabIndex] = useState(0);
    const [purchasedData, setPurchasedData] = useState([]); 
    const [selectedOrganization, setSelectedOrganization] = useState(organizationInfo[0]);
    const navigate = useNavigate();

    const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    useEffect(()=>{
        const value = parseInt(localStorage.getItem('tab'))
        setTabIndex(value? value:0);
    }, []);

    // get data: usage history
    useEffect(()=>{
        axios.get('tutors/credits/usageHistory/', {
            params: { timezone: localTimezone } 
        })
        .then(res=>{
            // console.log(localTimezone);
            // console.log(res.data.studentList);
            setUsages(res.data.usages);
            setOrganizationInfo(res.data.organizationInfo);
        })
        .catch(error=>{
            console.log(error);
        })
    }, []);

    // get data: purchase history
    useEffect(()=>{
        axios.get('tutors/credits/purchaseHistory/')
        .then(res=>{
            setPurchasedData(res.data.purchasedData);
        })
        .catch(error=>{
            console.log(error);
        })
    }, []);
   
    const HandleTabIndex = (t)=>{
        setTabIndex(t);
        localStorage.setItem('tab', t);
    };

    const handleSelectedOrganizaiton = (value) =>{
        setSelectedOrganization(value);
        localStorage.setItem('organization', value);
    };

    return (
        <>
            <Helmet>
                <title>
                    Credits - Test Center Admin
                </title>
            </Helmet>
            <Header title='Test credits' />
            <div className='credits'>
                <div className='credits__cards'>
                    <div className='credits__tabs'>
                        <Tabs
                            tabs={TABS}
                            tabIndex={tabIndex}
                            onSelect={TABS.map((_tab, t) => (
                                () => HandleTabIndex(t)
                            ))}
                        />
                    </div>
                    {tabIndex===0&& 
                        <div className='creditsPurchase__card'>
                            <div className='creditsPurchase__card_summary'>
                                <div className='credits__card_dropDown'>
                                {Object.keys(usages).length > 0 && <Dropdown
                                        className='small'
                                        data={Object.keys(usages)}
                                        value={selectedOrganization}
                                        onSelect={value => handleSelectedOrganizaiton(value)}
                                        setDefault={value => setSelectedOrganization(value)}
                                        placeholder='organization'
                                    />}
                                </div>
                                <div className='credits__card_contents'>
                                    <p>Total <b className=''>{organizationInfo[selectedOrganization]?.totalCredits || 0}</b></p>
                                    <p>Used <b className=''>
                                    {organizationInfo[selectedOrganization]?.totalCredits !== undefined && 
                                    organizationInfo[selectedOrganization]?.remainingCredits !== undefined ?
                                    organizationInfo[selectedOrganization]?.totalCredits - organizationInfo[selectedOrganization]?.remainingCredits : 0}
                                    </b></p>
                                    <p>Remaining <b className=''>{organizationInfo[selectedOrganization]?.remainingCredits || 0}</b></p>
                                </div>
                            </div>
                            <Table 
                                header={['Organization', 'Description', 'Purchase date', 'Quantity', 'Payment']}
                                rows={purchasedData.filter(d=>d.organization===selectedOrganization).map(data => ([
                                        data.organization,
                                        data.description,
                                        new Date(data.purchasedAt).toLocaleDateString(),
                                        data.quantity,
                                        new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(data.payments),
                                    ]))
                                } 
                            />
                        </div>
                    }

                    {tabIndex===1&&
                        <div className='credits__card'>
                            <div className='credits__card_summary'>
                                <div className='credits__card_dropDown'>
                                    {Object.keys(usages).length > 0 && <Dropdown
                                        className='small'
                                        data={Object.keys(usages)}
                                        value={selectedOrganization}
                                        onSelect={value => handleSelectedOrganizaiton(value)}
                                        setDefault={value => setSelectedOrganization(value)}
                                        placeholder='organization'
                                    />}
                                </div>
                                <div className='credits__card_contents'>
                                    <p>Total <b className=''>{organizationInfo[selectedOrganization]?.totalCredits.toFixed(2) || 0}</b></p>
                                    <p>Used <b className=''>
                                    {organizationInfo[selectedOrganization]?.totalCredits !== undefined && 
                                    organizationInfo[selectedOrganization]?.remainingCredits !== undefined ?
                                    organizationInfo[selectedOrganization]?.totalCredits - organizationInfo[selectedOrganization]?.remainingCredits.toFixed(2) : 0}
                                    </b></p>
                                    <p>Remaining <b className=''>{organizationInfo[selectedOrganization]?.remainingCredits.toFixed(2) || 0}</b></p>
                                </div>
                            </div>
                            <Table 
                                header={['Organization', 'Alias', 'Month', 'Count']}
                                rows={Object.entries(usages[selectedOrganization] || {}).map(([month, count]) => ([
                                    selectedOrganization,
                                    organizationInfo[selectedOrganization]['alias'] || '',
                                    month,
                                    count
                                ]))}
                                onSelectCell={Object.entries(usages[selectedOrganization] || {}).map(([month]) => ([
                                    null,
                                    null,
                                    () => navigate(`/credits/${organizationInfo[selectedOrganization]['alias']}/${month}`),
                                    null
                                ]))}
                            />
                        </div>
                    }
                </div>
            </div>
        </>
    );
}

export default Credits;